var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.7879 72.36C94.8946 71.26 93.3946 70.8533 92.0746 71.3267C88.3746 72.6533 84.3613 73.3333 80.1346 73.3333C59.9146 73.3333 43.4679 56.88 43.4679 36.6667C43.4679 24.5 49.4746 13.1733 59.5346 6.36C60.6746 5.58667 61.2213 4.19333 60.9146 2.85333C60.6079 1.51333 59.5079 0.5 58.1413 0.3C56.5813 0.0733333 55.0279 0 53.4679 0C25.8946 0 3.46793 22.4267 3.46793 50C3.46793 77.5733 25.8946 100 53.4679 100C70.9679 100 86.8879 91.1067 96.0413 76.2133C96.7813 75.0067 96.6746 73.4667 95.7879 72.36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.0b82d8a889e21389aca64a0f004e0402.svg";
export { ForwardRef as ReactComponent };